/**
 * Bring into this book. Hardcoded system text. Do not paraphrase.
 * Spec: docs/series/bring-into-book-spec.md
 */

import { BRING_DEST_NOTES, BRING_EMPTY_LIST, BRING_LEDE as BRING_LEDE_COPY } from '../utils/writerCopy';

export const BRING_TITLE = 'Bring into this book';

export const BRING_LEDE = BRING_LEDE_COPY;

export const BAND_FROM_SERIES = 'From series planning';
export const BAND_THIS_BOOK = 'This book';

export const EMPTY_THIS_BOOK = 'Not established in this book yet.';

export const DEST_NOTES = BRING_DEST_NOTES;

export const EMPTY_LIST = BRING_EMPTY_LIST;

export const ALL_DONE = 'This draft is finished.';

export const STATE_ACCEPTED = 'Accepted.';
export const STATE_SKIPPED = 'Skipped.';

export const KIND_LABEL = {
  people: 'People',
  world: 'World',
  custom: 'Custom',
  theme: 'Series Theme',
};
